import { useContext } from 'react'

import { orderTransactionTypes } from '@/constants'
import AppContext from '@/context/AppContext'

const useTransactionTypes = () => {
  const { context } = useContext(AppContext)

  const allowedTransactionTypes = context?.merchantInfo?.preferences?.transaction_types
  const allowsUnifiedFlow = context?.merchantInfo?.preferences?.allows_unified_flow
  const transactionTypeSelectedByUser = context?.orderInfo?.type
  const allowsInstantExchanges = context?.merchantInfo?.preferences?.allows_instant_exchanges

  /**
   * @returns {String} "refund", "exchange" or "mixed"
   */
  const getOrderTransactionType = () => {
    if (allowsUnifiedFlow) {
      const uniqueActionTypes = [...new Set(context?.items?.map(item => item.actionType))]

      return uniqueActionTypes?.length > 1 ? orderTransactionTypes.mixed : uniqueActionTypes?.[0]
    }

    return transactionTypeSelectedByUser
  }

  const isInstant = () => {
    const transactionType = getOrderTransactionType()

    const refundMethod = context?.orderInfo?.allowed_refund_methods?.find(
      rm => rm.name === context?.orderInfo?.refundType
    )

    if (transactionType === orderTransactionTypes.mixed || transactionType === orderTransactionTypes.exchange) {
      return context?.orderInfo?.is_instant_exchange_allowed
    }

    return refundMethod?.is_instant
  }

  return {
    allowedTransactionTypes,
    allowsUnifiedFlow,
    transactionTypeSelectedByUser,
    getOrderTransactionType,
    isInstant,
    allowsInstantExchanges,
  }
}

export default useTransactionTypes
